const TEXT = {
    COMMON: {
        CONTINUE: "Fortsett",
        BACK: "Tilbake",
    },
    PAGE_HEADING: "Eierskifte",
    CONFIRM_ID: {
        HEADING: "Bytte eier av et mobilabonnement",
        BANKID_DESCRIPTION:
            "Her kan du bestille eierskifte av et Telia mobilabonnementet, og signere digitalt med BankID. Det er den nye eieren (som skal overta mobilnummeret) som starter denne bestillingen, og den nåværende eier vil bli varslet for å godkjenne til slutt.",
        CREDIT_CHECK_DESCRIPTION: "Vi kommer til å gjennomføre en kredittsjekk av den nye eieren.",
        BUTTON: {
            BANK_ID: "BankID",
        },
        RESET_BANKID: "Logg ut",
        BANK_ID_VERIFIED: {
            HEADING: "Vi hentet disse opplysningene fra BankID",
            CONTINUE_DESCRIPTION: 'Trykk "Fortsett" for å gå videre eller ',
            NEW_VERIFICATION: "gjør en ny BankID verifisering",
        },
        BANK_ID_MANDATORY_BUT_NOT_AVAILABLE:
            "Dette steget krever verifisering med BankID, men BankID ser ut til å være nede. Vennligst prøv igjen senere. [tlo]",
    },
    CONFIRM_NUMBER: {
        HEADING: "Bekreft mobilnummer",
        DESCRIPTION:
            "Angi mobilnummer du ønsker å overta eierskapet av. Vi er nødt til å vite om du som ny eier har tilgang til dette mobilabonnement. Du må derfor bekrefte dette med engangskode som sendes på SMS.",
        NUMBER_FIELD: {
            LABEL_TEXT: "Mobilnummer som overføres",
            PLACEHOLDER: "Mobilnummer",
        },
    },
    SUMMARY: {
        HEADING: {
            MAIN_B2C: "Abonnementet du ønsker å ta over",
            MAIN_B2B: "Hvilket abonnement vil du ha?",
            RELATED: "Tilhørende avtaler",
        },
        SUBSCRIPTION_INFORMATION: {
            NUMBER: "Mobilnummeret som overføres:",
            NEW_LEGALOWNER: "Overføres til:",
            EXISTING_LEGALOWNER: "Nåværende eier:",
            EXISTING_PRODUCTUSER: "Nåværende bruker:",
            SUBSCRIPTION: "Abonnement:",
            PRICE: "Pris for abonnement:",
            LEASE_TIME: "Avtaletid:",
            NO_LEASETIME: "Ingen avtaletid",
            END_DATE: "Sluttdato for avtaletid:",
            PER_MONTH: "/md.",
        },
        CREDIT_CHECK_DENIED:
            "Grunnet avslag på din kredittsjekk, så vil du få tildelt et Kontantkort hvis du fullfører eierskiftet.",
        RELATED_ACCOUNTS: {
            ALREADY_CUSTOMER: "Du er allerede kunde hos oss!",
            WHICH_INVOICE: "Hvilken av dine fakturaer skal mobilnummeret knyttes til?",
            CUSTOMER_NUMBER: "Kundenummer:",
            NO_LEASETIME: "Ingen avtaletid",
            CREATE_NEW: "Opprett nytt kundenummer",
        },
        RELATED_INFORMATION: {
            PRODUCT: "Produkt",
            PRICE: "Pris",
            LEASE_TIME: "Avtaletid",
            MODEL: "Mobiltelefon",
            IMEI: "Imei",
            NO_LEASETIME: "Ingen avtaletid",
            END_DATE: "Sluttdato for avtaletid",
            REMAINING_MONTHS: "Gjenværende måneder",
            REMAINING_COST: "Gjenværende beløp",
            SIM_NUMBER: "SIM-nummer",
            SWITCH_KEEP_AGREEMENT: (legalOwner: string) =>
                `Jeg ønsker <u>ikke</u> å ta over Svitsj-avtalen. ${legalOwner} vil fortsette å betale ned restbeløpet som vanlig.`,
            SWITCH_KEEP_AGREEMENT_MODAL_TEXT: (legalOwner: string) =>
                `Ved å ikke overføre Svitsj-avtalen vil nåværende eier, ${legalOwner} fortsette å betale ned restbeløpet som vanlig.`,
            SWITCH_KEEP_AGREEMENT_MODAL_PLUS_INSURANCE_TEXT:
                " Plussforsikringen tilhørende Svitsj-avtalen vil bli avsluttet fordi den er knyttet til mobilnummeret som du nå overtar, men du vil fortsatt ha skjermforsikring inkludert uten ekstra kostnad.",
            LEASE_KEEP_AGREEMENT: (legalOwner: string) =>
                `Jeg ønsker <u>ikke</u> å ta over nedbetalingsavtalen. ${legalOwner} vil fortsette å betale ned restbeløpet som vanlig.`,
            LEASE_KEEP_AGREEMENT_MODAL_TEXT: (legalOwner: string) =>
                `Ved å ikke overføre nedbetalingsavtalen vil nåværende eier, ${legalOwner} fortsette å betale ned restbeløpet som vanlig. Plussforsikringen tilhørende avtalen vil bli avsluttet fordi den er knyttet til mobilnummeret som du nå overtar, men du vil fortsatt ha skjermforsikring inkludert uten ekstra kostnad.`,
            WILL_AUMATICALLY_TRANSFER: "Følger automatisk med abonnementet",
        },
        DISCLAIMER_LINKS: {
            HEADING: "Last ned våre vilkår (PDF)",
            FIRST: "Telia Norge generelle vilkår",
            SECOND: "Telia Finance leievilkår",
            THIRD: "Telia Norge Svitsj-vilkår",
            FOURTH: "Svitsj forsikringsvilkår",
        },
        AGREEMENT: {
            RELATED_INSURANCE: "Tilhørende avtale",
            CAN_KEEP: "Denne avtalen kan velges bort",
        },
    },
    REQUEST_TRANSFER_OF_OWNERSHIP: {
        HEADING: "Bestill eierskifte",
        DESCRIPTION_B2C: (name: string) =>
            `${name} må godkjenne overføringen med BankID. Dette gjøres ved at vedkommende får en lenke til signering på SMS. Du kan velge å sende lenken direkte til ${name}, eller sende lenken til deg selv og videresende den til ${name}.`,
        DESCRIPTION_B2B_UNKNOWN_ADMIN: (orgName: string) =>
            `En bedriftsadministrator fra ${orgName} må godkjenne denne overføringen. Dette gjøres ved at vedkommende får en SMS med lenke til godkjenningen. Hvis du vet hvem dette er så kan du velge å sende lenken direkte til denne administratoren med en gang, eller sende lenken til deg selv og videresende den senere når du har funnet ut hvem som kan godkjenne.`,
        DESCRIPTION_B2B: (orgName: string) =>
            `En bedriftsadministrator fra ${orgName} må godkjenne denne overføringen. Dette gjøres ved at vedkommende får en SMS med lenke til signeringen. Vennligst velg et av mobilnumrene i listen under for utsending av SMS.`,
        NUMBER_FIELD: {
            LABEL_TEXT: "Mobilnummeret som skal motta lenken",
            PLACEHOLDER: "Fyll inn mobilnummer her...",
        },
        NO_COMPANY_ADMINS: (orgName: string) =>
            `En bedriftsadministrator fra ${orgName} må godkjenne denne overføringen, men det er ikke registrert noe mobilnummer tilknyttet en bedriftsadministrator for denne bedriften. Du må kontakte denne bedriften og be dem opprette en bedriftsadministrator. Når dette er gjort kan du prøve å gjennomføre eierskiftet igjen.`,
        CONSENT_GIVEN_BY_COMPANY_ADMINS: (orgName: string, requestedTransferDate: string) =>
            `Bedriftsadministrator fra ${orgName} har godkjent din overføring, og den vil bli gjennomført den ${requestedTransferDate} hvis du nå fullfører din bestilling.`,
        BUTTON_TEXT: "Send lenke på SMS",
        ORDER_VALIDITY_DESCRIPTION_B2C: (name: string) =>
            `Forespørselen er gyldig i 30 dager og vil bli gjennomført med en gang ${name} godkjenner.`,
        ORDER_VALIDITY_DESCRIPTION_B2B:
            "Forespørselen er gyldig i 30 dager og vil bli gjennomført med en gang bedriftsadministrator godkjenner såfremt ikke en annen dato er angitt av bedriftsadministrator.",
        ORDER_VALIDITY_DESCRIPTION_GENERAL:
            "Forespørselen er gyldig i 30 dager og vil bli gjennomført med en gang eier (eller en person med eieransvar) godkjenner såfremt ikke en annen dato blir angitt av eksisterende eier.",
        ORDER_CONFIRMATION: {
            HEADING_PRE_APPROVED: "Vi har registrert din bestilling av eierskifte.",
            HEADING: "Forespørsel om godkjenning av eierskifte er sendt.",
            DESCRIPTION:
                "Du får en SMS når det er gjennomført. Etter mobilnummeret er overført til deg, kan du administrere ditt nye abonnement på <a class='link' href='https://www.telia.no/minside/' target='_blank'>Min Side</a>.",
        },
        BACK_BUTTON_TEXT: "Tilbake til forsiden",
    },
    LANDING_PAGE: {
        HEADING: "Bestilling av eierskifte",
        CONSENT_HEADING: "Forespørsel om godkjenning av eierskifte",
        REQUEST_RECEIVED: (name: string) =>
            `Vi har mottatt en bestilling på overtagelse av ditt mobilnummer fra ${name}`,
        LIST: {
            DESCRIPTION: (name: string) => `Ved eierskifte av ditt mobilnummer vil ${name} overta følgende:`,
            ITEM_1: "Mobilnummer med tilhørende abonnement",
            ITEM_2: "Eventuell avtaletid på abonnement og/eller delbetalingsavtale tilhørende mobilnummeret",
        },
        BANK_ID_CONSENT:
            "Gjennomføringen av eierskifte krever ditt samtykke, samt sikker bekreftelse av din identitet med BankID.",
        BUTTON: {
            BANK_ID: "BankID",
            CONFIRM_TRANSFER: "Godta eierskifte",
        },
        BANK_ID_VERIFIED: {
            HEADING: "Vi hentet disse opplysningene fra BankID",
        },
        INFORMATION_HEADING: {
            MAIN: "Avtaler som overføres",
            RELATED: "Tilhørende avtaler",
        },
        ORDER_NOT_FOUND:
            "Denne lenken ser ikke ut til å være gyldig lenger. Prøv en annen nettleser hvis du mener den bør være gyldig.",
        ORDER_CONFIRMATION_HEADER: "Eierskifte er fullført.",
        ORDER_CONFIRMATION_DESCRIPTION: (name: string) => `${name} vil få beskjed på SMS.`,
        BACK: "Tilbake til forsiden",
        SWITCH_KEEP_AGREEMENT_DESCRIPTION: "Du vil fortsette å betale ned restbeløpet på Svitsj-avtalen som vanlig.",
        SWITCH_KEEP_AGREEMENT_PLUS_INSURANCE:
            " Plussforsikringen tilhørende Svitsj-avtalen vil bli avsluttet fordi den er knyttet til mobilnummeret som du nå overtar, men du vil fortsatt ha skjermforsikring inkludert uten ekstra kostnad.",
        LEASE_KEEP_AGREEMENT_DESCRIPTION: (newLegalOwner?: string) =>
            `${
                newLegalOwner || "Ny eier"
            } har valgt å ikke overføre delbetalingen på telefonen. Du vil fortsette å betale ned restbeløpet på delbetalingen som vanlig. Tilhørende forsikring vil bli avsluttet fordi den er knyttet til mobilnummeret som du nå overfører.`,
        RELATED_PHONE: "Tilhørende telefon",
        KEEP_AGREEMENT_DESCRIPTION: "Denne avtalen er valgt bort av ny eier",
    },
    LANDING_PAGE_B2B: {
        HEADING: "Bestilling av eierskifte",
        REQUEST_RECEIVED: (name: string, number: string) =>
            `Vi har mottatt en bestilling fra ${name} om overtagelse av mobilnummeret ${number} tilhørende deres bedrift.`,
        DESCRIPTION: "Forespørselen er gyldig i 30 dager fra bestillingstidspunkt.",
        CHOOSE_DATE: {
            HEADING: "Velg overføringsdato:",
        },
        CHOSEN_DATE: {
            HEADING: "Valgt overføringsdato:",
            DESCRIPTION: "Hvis dagens dato velges, vil eierskifte skje umiddelbart.",
        },
        PIN_CONSENT: {
            HEADING: "Godta eierskifte",
            DESCRIPTION: (name: string) =>
                `Gjennomføringen av eierskifte til ${name} krever ditt samtykke gjennom engangskode sendt på SMS.`,
        },
        NUMBER_FIELD: {
            LABEL_TEXT: "Ditt mobilnummer",
            PLACEHOLDER: "Ditt mobilnummer",
        },
        BUTTON: {
            CONFIRM_TRANSFER: "Godta eierskifte",
            ONE_TIME_PIN: "Gi samtykke via engangskode",
        },
    },
    LANDING_PAGE_TO_B2B: {
        HEADING: "Forespørsel om eierskifte",
        REQUEST_RECEIVED: (name: string, number: string, transferDate: string) =>
            `<span class="telia-sans-medium">${name}</span> ønsker å overta telefonnummer <span class="telia-sans-medium">${number}</span>. Du har fått denne forespørselen fordi du er oppgitt som kontaktperson/eier av dette nummeret. Ved å godkjenne overføringen samtykker du til at nummeret overføres den <span class="telia-sans-medium">${transferDate}</span>.`,
        DESCRIPTION: "Forespørselen er gyldig i 30 dager fra bestillingstidspunkt.",
        PIN_CONSENT: {
            HEADING: "Identifisering med engangskode",
            DESCRIPTION:
                "For å svare på forespørselen må du først identifisere deg med en engangskode som du får tilsendt på SMS.",
        },
        SUMMARY: {
            HEADING: "Oppsummering",
        },
        CHOSEN_DATE: {
            HEADING: "Valgt overføringsdato:",
            DESCRIPTION: "Hvis dagens dato velges, vil eierskifte skje umiddelbart.",
        },
        CHOOSE_DATE: {
            HEADING: "Velg overføringsdato:",
        },
        ORDER_NOT_FOUND: {
            HEADING: "Denne forespørselen er ikke lenger aktiv",
            TEXT: "Årsaken til dette kan være at godkjenningen allerede har blitt gjennomført, eller at tiden for å besvare den har utløpt.",
            HELP_TEXT:
                "Mistenker du at det har skjedd en feil? Ta kontakt med <a class='link' href='https://www.telia.no/bedrift/kundeservice/' target='_blank'>kundeservice</a> så hjelper vi deg.",
        },
        BUTTON: {
            CONFIRM_TRANSFER: "Godta eierskifte",
            ONE_TIME_PIN: "Gi samtykke via engangskode",
        },

        VERIFICATION: {
            CODE_VERIFIED: "Mobilnummeret er verifisert",
        },
        VERIFICATION_FIELD: {
            PHONE_TEXT: "Ditt mobilnummer",
            PHONE_PLACEHOLDER: "",
            PIN_TEXT: "Engangskode",
            PIN_PLACEHOLDER: "",
            PIN_FOOTER_TEXT_NEUTRAL: "Skriv inn koden du har mottatt på SMS",
            PIN_FOOTER_TEXT_APPROVED: "Koden er verifisert",
            BUTTON: {
                SEND_PIN_TEXT: "Send kode på SMS",
                NEXT_STEP: "Gå videre",
            },
        },
        NO_TELIA_NUMBER: {
            HEADING: "Mobilnummeret tilhører ikke Telia.",
            DESCRIPTION: "Mobilnummeret er ikke knyttet til noe Telia abonnement.",
        },
    },
    LANDING_PAGE_B2B_APPROVAL: {
        APPROVAL_HEADING: "Svar på forespørsel",
        RECEIVED_APPROVAL: (name: string, number: string, transferDate: string) =>
            `Ved å godkjenne overføringen samtykker du til at telefonnummeret  **${number}** overføres til **${name}**. Ønsket tidspunkt for overføring er satt til: **${transferDate}**.`,
        RECEIVED_APPROVAL_2: (number: string) =>
            `Endelig tidspunkt vil bli sendt på SMS til ${number} når dette er bekreftet.`,
        RECEIVED_APPROVAL_TEXT: (breakageFee: number) =>
            `${
                breakageFee
                    ? `Vi gjør oppmerksom på at dersom nummeret er tilknyttet et mobilabonnement med bindingstid, vil overføring før bindingstidens slutt medføre bruddgebyr (${breakageFee},-) for nåværende juridisk eier i henhold til kontrakt.`
                    : "Vi gjør oppmerksom på at dersom nummeret er tilknyttet et mobilabonnement med bindingstid, vil overføring før bindingstidens slutt medføre bruddgebyr i henhold til kontrakt."
            }`,
        BANK_ID_INFO: "For å godkjenne overføringen må du identifisere deg med BankID i neste steg.",
        RADIO_BUTTON_FIELD: {
            APPROVAL_TEXT: "Jeg godkjenner overføringen",
            REJECTION_TEXT: "Jeg avslår overføringen",
        },
        REJECT_DESCRIPTION: "Velg de alternativene som best beskriver hvorfor du avslår denne forespørselen:",
        BUTTON: {
            NEXT_STEP: "Fullfør og send",
            REJECT: "Avslå overtagelse",
            BANK_ID: "Godkjenn med BankID",
        },
        BANK_ID_CONSENT:
            "Gjennomføringen av eierskifte krever ditt samtykke, samt sikker bekreftelse av din identitet med BankID",
        BANK_ID_NEW_CONSENT: "Har du gjennomført BankID med feil person? Gjør en ny bekreftelse her:",
        BANK_ID_VERIFIED: "Vi hentet disse opplysningene fra BankID:",
        START_OVER: (hasAcceptedAsOrg: boolean) =>
            hasAcceptedAsOrg
                ? "Jeg har valgt feil organisasjon og ønsker å starte overføringsprosessen på nytt"
                : "Jeg har identifisert meg med feil person og ønsker å starte overføringsprosessen på nytt",
    },
    LANDING_PAGE_B2B_REJECTION: {
        REJECTION_HEADING: "Forespørselen er avslått",
        RECEIVED_REJECTION: (number: string) =>
            `Vi har registrert at forespørselen om eierskifte av telefonnummeret <span class="telia-sans-medium">${number}</span> er avslått.`,
        REJECTION_TEXT: `Mistenker du at det har skjedd en feil? Ta kontakt med  <a class='link' href='https://www.telia.no/bedrift/kundeservice/' target='_blank'>kundeservice</a> så hjelper vi deg.`,
        BUTTON_TEXT: "Gå til forsiden",
    },
    LANDING_PAGE_B2B_IDENTIFICATION: {
        HEADING: "Identifisering med BankID",
        IDENTIFICATION_TEXT: (name: string, number: string) =>
            `For å kunne godkjenne overføring av telefonnummeret <span class="telia-sans-medium">${number}</span> til <span class="telia-sans-medium">${name}</span> må du identifisere deg med BankID.`,
        IDENTIFICATION_TEXT_2: `BankID er en sikker identitetsløsning som forsikrer oss om at du er den du utgir deg for å være, og at du har rettigheter til å bekrefte overføringen av gjeldende mobilnummer. Ta kontakt med <a class='link' href='https://www.telia.no/bedrift/kundeservice/' target='_blank'>kundeservice</a> dersom du ikke har BankID.`,
    },
    LANDING_PAGE_B2B_APPROVED: {
        APPROVAL_HEADING: "Forespørselen er registrert som godkjent",
        RECEIVED_APPROVAL:
            "På overføringsdatoen vil mobilnummeret bli overført til ny eier og du vil ikke lenger ha tilgang til dette nummeret.",
        REJECT_DESCRIPTION: "Velg de alternativene som best beskriver hvorfor du avslår denne forespørselen:",
        BUTTON_TEXT: "Gå til forsiden",
    },
    ENTER_NUMBER_OR_EMAIL: {
        HEADING: "Overføring av mobilnummer",
        CONFIRM_HEADING: "Forespørsel er registrert",
        RECEIPT_PARAGRAPH:
            "Forespørselen om eierskifte/overføring er sendt til den du oppga som juridisk eier av abonnementet. Du vil få beskjed på SMS når dette er godkjent",
        TRANSFER_PARAGRAPH:
            "Du har bestilt en overføring av et mobilnummer inn til Telia. Det er kanskje du som bruker mobilnummeret, men det er likevel kun eieren som kan godkjenne overføringen til Telia.",
        IS_LEAGAL_OWNER_LINK: "Gå direkte til godkjenning av overføring",
        APPROVAL_PARAGRAPH: `Slik fullføres overføringen:<br />
            <ul>
                <li>Tast mobilnummeret til eieren i feltet nedenfor</li>
                <li>Den du mener er eier vil så motta en SMS for godkjenning av overføring til Telia</li>
                <li>Når overføringen er godkjent, så vil mobilnummeret bli overført til Telia med deg som eier</li>
            </ul>`,
        BACK_TO_FRONTPAGE: "Tilbake til forsiden",

        REQUEST_RECEIVED: (name: string) =>
            `Vi har mottatt en bestilling på overtagelse av ditt mobilnummer fra ${name}`,
        ORDER_CONFIRMATION: `Eierskifte har blitt godkjent og sendt inn.`,
        ORDER_REJECTED: `Dette eierskiftet har tidligere blitt avslått. Prøv på nytt ved å fylle ut skjemaet under.`,
        ORDER_NOT_FOUND:
            "Denne lenken ser ikke ut til å være gyldig lenger. Prøv en annen nettleser hvis du mener den bør være gyldig.",
    },
    LANDING_PAGE_FROM_CHECKOUT: {
        HEADING: "Overføring av mobilnummer",
        CONFIRM_HEADING: "Bekreftelse registrert",
        REJECT_HEADING: "Avslått overføring",
        LIST: {
            DESCRIPTION_1: (name: string, phoneNumber: string) =>
                `Vi har mottatt en bestilling fra <span class="telia-sans-medium">${name}</span> med ønske om å ta over eierskapet av mobilnummer <span class="telia-sans-medium">${phoneNumber}</span>.`,
            DESCRIPTION_2: `Ved å godkjenne denne av overføring, så vil det juridiske eierskapet overføres til den nye eieren.`,
            DESCRIPTION_3:
                "Dersom du ønsker å godkjenne overføringen av mobilnummeret, og det juridiske eierskapet, gjør du dette enkelt ved å benytte BankID for å bekrefte din identitet og gi ditt samtykke.",
        },
        BANK_ID_CONSENT:
            "Gjennomføringen av eierskifte krever ditt samtykke, samt sikker bekreftelse av din identitet med BankID",
        BANK_ID_VERIFIED: "Vi hentet disse opplysningene fra BankID:",
        BUTTON: {
            REJECT: "Avslå overtagelse",
            BANK_ID: "Godkjenn med BankID",
            CONFIRM_TRANSFER: "Godta eierskifte",
        },
        REJECT_DESCRIPTION: "Velg de alternativene som best beskriver hvorfor du avslår denne forespørselen:",
        ORDER_NOT_FOUND:
            "Denne lenken ser ikke ut til å være gyldig lenger. Prøv en annen nettleser hvis du mener den bør være gyldig.",
        ORDERER_IS_ORGANIZATION:
            "Den som har bestilt denne ordre med eierskifte er en bedriftseier, vennligst kontakt vårt kundesenter.",
        ORDER_CONFIRMATION: (newLegal: string) =>
            `Din bekreftelse er registrert. <br /> ${newLegal} vil bli varslet på e-post om at du har godkjent overføringen.`,
        ORDER_REJECTED: (newLegal: string) =>
            `Vi har registrert at du har avslått overføringen. <br /> Vi vil kontakte ${newLegal} for å avklare videre prosess.`,
        BACK_TO_FRONTPAGE: "Tilbake til forsiden",
    },
    ERROR: {
        ONLY_PRODUCT_USER_ALLOWED:
            "Dette mobilnummer er tilknyttet en juridisk eier. Eierskifte kan kun utføres for brukere på en faktura.",
    },
    RECEIPT: {
        REJECTED: {
            HEADING: "Eierskifte er avslått",
            DESCRIPTION:
                "Vi har registrert at du har avslått eierskiftet. Vi vil sende en SMS til den som bestilte eierskifte om din avgjørelse.",
        },
    },
    CONSENT_FORMER_LEGAL: {
        HEADING: "Forespørsel om godkjenning av eierskifte",
        REQUEST_RECEIVED: (name: string, number: string) =>
            `<span class="telia-sans-medium">${name}</span> ønsker å overta telefonnummer <span class="telia-sans-medium">${number}</span>. Du har fått denne forespørselen fordi du er oppgitt som kontaktperson/eier av dette nummeret. `,
        TRANSFER_DATE_INFO: (transferDate: string) =>
            `Ved å godkjenne overføringen samtykker du til at nummeret overføres den <span class="telia-sans-medium">${transferDate}</span>, og at det juridiske eierskapet overføres til den nye eieren.`,
        ORDER_NOT_FOUND: {
            HEADING: "Denne forespørselen er ikke lenger aktiv",
            TEXT: "Årsaken til dette kan være at godkjenningen allerede har blitt gjennomført, eller at tiden for å besvare den har utløpt.",
            HELP_TEXT:
                "Mistenker du at det har skjedd en feil? Ta kontakt med <a class='link' href='https://www.telia.no/bedrift/kundeservice/' target='_blank'>kundeservice</a> så hjelper vi deg.",
        },
        RECEIVED_APPROVAL_TEXT: (breakageFee: number) =>
            `${
                breakageFee
                    ? `Vi gjør oppmerksom på at dersom nummeret er tilknyttet et mobilabonnement med bindingstid, vil overføring før bindingstidens slutt medføre bruddgebyr (${breakageFee},-) for nåværende juridisk eier i henhold til kontrakt.`
                    : "Vi gjør oppmerksom på at dersom nummeret er tilknyttet et mobilabonnement med bindingstid, vil overføring før bindingstidens slutt medføre bruddgebyr i henhold til kontrakt."
            }`,
        APPROVAL_HEADING: "Forespørselen er registrert som godkjent",
        RECEIVED_APPROVAL:
            "På overføringsdatoen vil mobilnummeret bli overført til ny eier og du vil ikke lenger ha tilgang til dette nummeret.",
        ORDER_CONFIRMATION_DESCRIPTION: (name: string) => `${name} vil få beskjed på SMS.`,
        RELATED_PHONE: "Tilhørende telefon",
        IDENTIFICATION_TEXT: (name: string, number: string) =>
            `For å kunne godkjenne overføring av telefonnummeret <span class="telia-sans-medium">${number}</span> til <span class="telia-sans-medium">${name}</span> må du identifisere deg med BankID.`,
        BANK_ID_VERIFIED: "Vi hentet disse opplysningene fra BankID:",
        OTP: {
            DESCRIPTION:
                "For å vite at du tilhører samme bedrift som det nummer som skal overføres - så sender vi deg en engangskode på SMS.",
            PHONE_NUMBER_LABEL: "Ditt mobilnummer",
            CODE_LABEL: "Engangskode",
            SEND_CODE: "Send engangskode",
            VERIFY_CODE: "Bekreft kode",
            CHANGE_NUMBER: "Bruk et annet nummer",
            VERIFIED: (phoneNumber: string) => `Engangskode er bekreftet for ${phoneNumber}.`,
        },
        START_OVER: (hasAcceptedAsOrg: boolean) =>
            hasAcceptedAsOrg
                ? "Jeg har valgt feil organisasjon og ønsker å starte på nytt"
                : "Jeg har identifisert meg med feil person og ønsker å starte på nytt",
        BUTTON: {
            NEXT_STEP: "Fullfør og send",
            REJECT: "Avslå overtagelse",
            BANK_ID: "Godkjenn med BankID",
            CONFIRM: "Godta eierskifte",
            ONE_TIME_PIN: "Gi samtykke via engangskode",
        },
        REJECT_DESCRIPTION: "Velg de alternativene som best beskriver hvorfor du avslår denne forespørselen:",
        REJECTED: {
            HEADING: "Eierskifte er avslått",
            DESCRIPTION:
                "Vi har registrert at du har avslått eierskiftet. Vi vil sende en SMS til den som bestilte eierskifte om din avgjørelse.",
        },
    },
} as const;

export default TEXT;
